<template>
  <div>
    <cycles :query="query" noFilter noCard></cycles>
  </div>
</template>

<script>
import Cycles from "@/components/Cycles/index.vue";
export default {
  components: { Cycles },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    query() {
      return {
        projectId: this.project.id,
      };
    },
  },
};
</script>

<style></style>
